// components/PersonalData.js
import React, { useState, useEffect } from 'react';
import { TextField, ListItem, ListItemText } from '@mui/material';
// import styled from 'styled-components';
import { BaseLabel, RowContainer, Input, InputHalf, AutoComplete } from '../../../styles/styleUtils';

import { getClientes } from '../../api';

function BusinessData({ formData, onInputChange, onAutoCompleteChange, disabled }) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    fetchFormas();
  }, []);
  const fetchFormas = async () => {
    const result = await getClientes();
    setOptions(result);
  };

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="cnpj">CNPJ</BaseLabel>
        <InputHalf
          disabled
          type="text"
          id="cpf"
          name="cpf"
          value={formData.cliente?.cpf}
          onChange={onInputChange}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="fundacao">
          Fundação
        </BaseLabel>
        <InputHalf
          type="date"
          id="nascimento"
          name="nascimento"
          value={formData.cliente?.nascimento ? new Date(formData.cliente?.nascimento).toISOString().split('T')[0] : ''}
          onChange={onInputChange}
          disabled
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="telefone">Telefone</BaseLabel>
        <InputHalf
          disabled
          type="tel"
          id="telefone"
          name="telefone"
          value={formData.cliente?.telefone}
          onChange={onInputChange}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="email">Email</BaseLabel>
        <InputHalf
          disabled={formData.cliente}
          type="tel"
          id="email"
          name="email"
          value={formData.cliente?.email}
          onChange={onInputChange}
        />
      </RowContainer>
    </div>
  );
}

export default BusinessData;
